import { render, staticRenderFns } from "./submission-panel-affiliate.vue?vue&type=template&id=7f7a4b55&scoped=true&"
import script from "./submission-panel-affiliate.vue?vue&type=script&lang=ts&"
export * from "./submission-panel-affiliate.vue?vue&type=script&lang=ts&"
import style0 from "./submission-panel-affiliate.vue?vue&type=style&index=0&id=7f7a4b55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7a4b55",
  null
  
)

export default component.exports